import styled, { css, keyframes } from 'styled-components';

import { PRIMARY_GREY, WHITE, DARK_BLACK } from 'constants/colours';

export const fadeInAnim = keyframes`
from { opacity: 0; }
to { opacity: inherit; }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background-color: rgba(9, 9, 9, 0.8);
  z-index: 1500;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const ModalContentContainer = styled.div<{ height?: string }>(
  ({ height }) => css`
    height: 100%;
    width: 95%;
    max-width: 1200px;
    height: ${height};
    @media only screen and (max-width: 1023px) {
      max-width: 80%;
    }
    @media only screen and (max-width: 767px) {
      max-width: calc(100% - 32px);
      height: fit-content;
      min-height: calc(100% - 16px);
      position: absolute;
      top: 0;
      margin: 16px 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `
);

export const ModalContentWrapper = styled.div<{
  maxHeight?: string;
  height?: string;
  marginBottom?: string;
  borderRadius?: string;
}>(
  ({ maxHeight, height, marginBottom, borderRadius }) => css`
    height: ${height};
    max-width: 100%;
    max-height: ${maxHeight};
    margin-bottom: ${marginBottom};
    display: flex;
    flex-direction: column;
    animation: ${fadeInAnim} 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    border-radius: ${borderRadius || '4px'};
    background-color: ${WHITE};
    padding: 24px;
    font-size: 14px;
    line-height: 20px;
    position: relative;
  `
);

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderText = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: ${DARK_BLACK};
  margin-bottom: 0;
`;

export const ModalCloseButton = styled.button`
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: ${DARK_BLACK};
  position: absolute;
  top: 24px;
  right: 24px;
`;

export const SubHeader = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
  color: ${PRIMARY_GREY};
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  @media (max-width: 400px) {
    flex-direction: column;
    > button {
      width: 100%;
    }
  }
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 14px;
  @media (max-width: 400px) {
    flex-direction: column-reverse;
    width: 100%;
    > button {
      width: 100%;
    }
  }
`;
